import { useQuery } from '@tanstack/react-query';
import { clientService } from '@services/client';
import { useTranslation } from '@hooks/useTranslation';
import { toast } from 'react-toastify';
import { Client } from '@models/client.model';
import { getErrorMessage } from '@utils/errorMessage';

export const CLIENTS_QUERY_KEY = ['clients', 'list'];

export const useClients = () => {
  const localeCommon = useTranslation('common');

  return useQuery<Client[], Error>({
    queryKey: CLIENTS_QUERY_KEY,
    queryFn: async () => {
      try {
        return await clientService.getClients();
      } catch (error: any) {
        toast.error(getErrorMessage(error, localeCommon['requestError']));
        throw error;
      }
    },
  });
};

export default useClients;
